"use client";

import type { ReactNode } from "react";
import * as ArtifactsClient from "@ai-sdk-tools/artifacts/client";

type Props = {
  children: ReactNode;
};

/**
 * Defensive wrapper for AI SDK Tools artifacts context.
 *
 * Different versions/export maps have used different provider names.
 * We resolve the provider at runtime from the module namespace so builds don't
 * fail if a named export changes.
 */
export function ArtifactsProvider({ children }: Props) {
  const ProviderImpl =
    (ArtifactsClient as any).ArtifactsProvider ??
    (ArtifactsClient as any).ArtifactProvider ??
    (ArtifactsClient as any).Provider;

  if (typeof ProviderImpl === "function") {
    return <ProviderImpl>{children}</ProviderImpl>;
  }

  // If the artifacts package doesn't expose a provider in this build,
  // fall back to rendering children (artifacts hooks may no-op).
  return <>{children}</>;
}

